import React from "react";
import {
  Collapse,
  Card,
  Badge,
  Carousel as AntCarousel,
  Button as AntButton,
  Image,
  Button,
} from "antd";
import {
  Home,
  AppWindow,
  Camera,
  DollarSign,
  MessageSquare,
  HelpCircle,
  CheckCircle,
  ChevronRight,
  Mail,
  Calendar,
  Users,
  Cpu,
  Cloud,
  Map,
  LogIn,
  LogInIcon,
} from "lucide-react";
import preview from "@assets/dashboard.png";
import "../landing.css";
const { Panel } = Collapse;

// Home Section Content
const HomeSection = () => (
  <div className="container py-5">
    <div className="row align-items-center">
      <div className="col-md-6 mb-4 mb-md-0">
        <h1 className="display-5 fw-bold mb-3"> Brilliance in Every Flash</h1>

        <div className="d-flex gap-3 justify-content-center">
          <AntButton
            size="large"
            className="big-animated-button text-decoration-none"
            type="primary"
            icon={<LogInIcon className="mt-1" />}
href={`${window.location.origin}/login`}
          >
            Login
          </AntButton>
        </div>
      </div>
      <div className="col-md-6">
        <div
          className="bg-light mt-3 rounded p-4 d-flex justify-content-center align-items-center"
          style={{ height: "320px" }}
        >
          <Image
            src={preview}
            alt="Preview"
            style={{
              borderRadius: "10px",
              objectFit: "cover",
              border: "1px solid #e5e5e5",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
            preview={false}
          />{" "}
        </div>
      </div>
    </div>
  </div>
);

// Features Section Content
const FeaturesSection = () => (
  <div className="container py-5 bg-light">
    <h2 className="text-center fw-bold mb-4 display-6">Powerful Features</h2>
    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
      {[
        {
          icon: <Cpu size={24} />,
          title: "Offline Feature",
          desc: "Automate routine tasks with AI-powered workflows",
        },
        {
          icon: <Cloud size={24} />,
          title: "Easy to Setup",
          desc: "Secure cloud storage with real-time synchronization",
        },
        {
          icon: <Users size={24} />,
          title: "Customize Data Analytics",
          desc: "Work together seamlessly with robust sharing tools",
        },
        {
          icon: <Calendar size={24} />,
          title: "Powerful Report Generation",
          desc: "Connect with your existing calendar systems",
        },
        {
          icon: <Map size={24} />,
          title: "Easy to track your Ships",
          desc: "Track progress and manage tasks efficiently",
        },
        {
          icon: <Mail size={24} />,
          title: "Email Notifications",
          desc: "Stay updated with customizable alerts",
        },
      ].map((feature, idx) => (
        <div key={idx} className="col">
          <Card className="h-100 shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center mb-3">
                <div className="p-2 rounded-circle bg-success-subtle me-3">
                  {feature.icon}
                </div>
                <h3 className="card-title h5 mb-0">{feature.title}</h3>
              </div>
              <p className="card-text text-muted">{feature.desc}</p>
            </div>
          </Card>
        </div>
      ))}
    </div>
  </div>
);

// FAQ Section Content
const FAQSection = () => (
  <div className="container py-5 bg-light">
    <div className="text-center mb-5">
      <h2 className="display-6 fw-bold mb-3">Frequently Asked Questions</h2>
      <p className="lead text-muted">
        Find answers to common questions about our application
      </p>
    </div>
    <div className="row justify-content-center">
      <div className="col-md-10 col-lg-8">
        <Collapse defaultActiveKey={["1"]}>
          <Panel header="How do I get started with the app?" key="1">
            <p>
              Getting started is easy! Simply sign up for an account, choose
              your subscription plan, and follow our quick setup guide. You'll
              be up and running in minutes.
            </p>
          </Panel>
          <Panel header="Can I export my data from the app?" key="2">
            <p>
              Yes, we offer multiple export options including CSV, Excel, and
              PDF formats. You can export all your data or select specific
              information as needed.
            </p>
          </Panel>
          <Panel header="Is there a free trial available?" key="3">
            <p>
              Absolutely! We offer a 14-day free trial with full access to all
              features. No credit card required to start your trial.
            </p>
          </Panel>
          <Panel header="How secure is my data?" key="4">
            <p>
              Security is our top priority. We use industry-standard encryption,
              regular security audits, and follow best practices to ensure your
              data remains secure and private.
            </p>
          </Panel>
          <Panel header="Can I use the app on my mobile device?" key="5">
            <p>
              Yes, our application is fully responsive and works on all devices.
              We also offer native apps for iOS and Android for an enhanced
              mobile experience.
            </p>
          </Panel>
          <Panel header="How often do you release updates?" key="6">
            <p>
              We release regular updates with new features and improvements
              approximately once a month. Security updates are deployed
              immediately as needed.
            </p>
          </Panel>
        </Collapse>
      </div>
    </div>
  </div>
);

export { HomeSection, FeaturesSection, FAQSection };
